import React from "react";
import { Link, useLocation } from "react-router-dom";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Package, Mail, Phone, FileDown } from "lucide-react";

export default function OrderSuccess() {
  const { state } = useLocation();
  const order = state?.order;
  const phoneToken = state?.phoneToken || "";

  return (
    <main className="max-w-2xl mx-auto px-6 py-20 text-center">
      <div className="w-20 h-20 rounded-full bg-primary/10 mx-auto flex items-center justify-center mb-6">
        <CheckCircle2 className="text-primary" size={40} />
      </div>
      <div className="overline mb-2">Order Confirmed</div>
      <h1 className="font-display text-4xl lg:text-5xl mb-3">Dhanyavaad!</h1>
      <p className="text-muted-foreground mb-8 max-w-md mx-auto">
        Your order has been received. A GST invoice is on its way to your inbox, and our team will reach out shortly to confirm delivery details.
      </p>

      {order && (
        <div className="border border-border rounded-2xl p-6 bg-card text-left mb-8" data-testid="order-summary">
          <div className="flex items-center justify-between mb-4">
            <div>
              <div className="overline mb-1">Order ID</div>
              <div className="font-medium font-mono">#{order.id?.slice(0, 8)}</div>
            </div>
            <div className="text-right">
              <div className="overline mb-1">Total</div>
              <div className="font-display text-2xl">₹{order.total?.toFixed(2)}</div>
            </div>
          </div>
          <div className="border-t border-border pt-4 space-y-2 text-sm">
            <div className="flex items-center gap-2"><Package size={14} className="text-muted-foreground" /> {order.items?.length} item(s)</div>
            <div className="flex items-center gap-2"><Mail size={14} className="text-muted-foreground" /> {order.user_email}</div>
            <div className="flex items-center gap-2"><Phone size={14} className="text-muted-foreground" /> {order.user_phone}</div>
          </div>
        </div>
      )}

      <div className="flex flex-wrap justify-center gap-3">
        {order?.id && (
          <Button
            variant="outline"
            className="btn-pill border-primary/30"
            onClick={() => window.open(`${API}/orders/${order.id}/invoice?token=${encodeURIComponent(phoneToken)}`, "_blank")}
            data-testid="success-invoice"
          >
            <FileDown size={14} className="mr-2" /> Download Invoice
          </Button>
        )}
        <Link to="/track"><Button variant="outline" className="btn-pill" data-testid="success-track">Track Order</Button></Link>
        {order?.id && (
          <Link to={`/orders/${order.id}`} state={{ token: phoneToken }}>
            <Button variant="outline" className="btn-pill" data-testid="success-details">Order Details</Button>
          </Link>
        )}
        <Link to="/shop"><Button variant="outline" className="btn-pill" data-testid="success-continue">Continue Shopping</Button></Link>
        <Link to="/"><Button className="btn-pill bg-primary text-primary-foreground" data-testid="success-home">Back to Home</Button></Link>
      </div>
    </main>
  );
}
